import { Image, Text, View } from "@react-pdf/renderer";
import CheckMark from "../../assets/images/others/checkmark.png";

const CheckBoxPDF = (props) => {
    return (
        <View
            style={{
                flexDirection: "row",
                gap: 5,
                alignItems: "flex-start",
                marginBottom: 1.5,
            }}
        >
            <View
                style={{
                    width: 12,
                    height: 12,
                    border: "1px solid #333",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {props.checked && <Image style={{ width: 7, height: 7 }} src={CheckMark} />}
            </View>
            <View>
                <Text style={{ fontSize: 10, marginTop: -2 }}>
                    {props.label} <Text style={{ fontSize: 9 }}>{props.subLabel}</Text>
                </Text>
                <Text style={{ fontSize: 8 }}>{props.desc}</Text>
            </View>
        </View>
    );
};

export default CheckBoxPDF;
